/**
 * The recorder stays on top of everything while recording, including app modals (Contact us / Book a demo at
 * modal + 1) and the HubSpot chat (2147483645-2147483647). The recorder is portaled to the end of <body>, and its
 * device menus and tooltips use the same value, so they win ties by DOM order.
 */
export const RECORDER_Z_INDEX = 2_147_483_647;
